import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE, getPathWithoutLang } from '../../constants/languages';

const LanguageRouter = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
      const pathWithoutLang = getPathWithoutLang(location.pathname);
      navigate(`/${DEFAULT_LANGUAGE}${pathWithoutLang}${location.search}${location.hash}`, { replace: true });
      return;
    }

    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }

    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang, i18n, navigate, location]);

  return <>{children}</>;
};

export default LanguageRouter;

